// dependencies
import { Map } from "immutable";

export const selectIsInitialized = (state) => state.page.getIn(["adminSettingsNotifications", "initialized"], false);
export const selectActiveSection = (state) =>
	state.page.getIn(["adminSettingsNotifications", "activeSection"], "asap-daily");
export const selectRequestingNotifications = (state) =>
	state.page.getIn(["adminSettingsNotifications", "awaitingRequests"], Map());
